// extracted by mini-css-extract-plugin
export default {"status":"fuBiLya0on","endpoints":"CBO-aK+d8S"};
    if(module.hot) {
      // 1648554201731
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  